import React, { useState, memo, useEffect, useRef } from 'react';
import { Form, Row, Col } from 'antd';
import { connect, useDispatch, useSelector } from 'react-redux';
import { formData } from '@model/dealRationale';
import { API } from '@service';
import 'draft-js/dist/Draft.css';
import DealItem from './formItem';
import { Button } from 'appkit-react';
import PropTypes from 'prop-types';
import InsightModal from '../../analysis/insightModal';
import Dropdown, { DEAL_RATIONALE } from '@modules/insights/insightsDropdown';
import actions from '@flux/action';
// import SectionComment from '@components/CommentCenter/SectionComment';
import SectionComment from 'src/ddvComment/SectionComment';
import CommentAnchor from 'src/ddvComment/directUser/CommentAnchor';

// import CommentAnchor from '@components/directUser/CommentAnchor';

// import '@style/modules/insights/dealRationale.scss';
import '../../../styles/modules/insights/dealRationale.scss';

const ShowButton = (props) => {
  const { show } = props;

  return <span>{show ? <Button {...props}>{props.text}</Button> : null}</span>;
};

ShowButton.defaultProps = {
  text: '',
  kind: 'primary',
  size: 'lg',
  show: null,
};

ShowButton.propTypes = {
  show: PropTypes.func,
  text: PropTypes.string,
  kind: PropTypes.string,
  size: PropTypes.string,
};

const DealRationale = ({ location, currentSubmoduleName }) => {
  const dispatch = useDispatch();
  const projectId = useSelector(({ common }) => common.currentId);

  const [editButton, setEditButton] = useState(true);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [comp, setComp] = useState({ left: [], right: [], top: [] });
  const modalRef = useRef(null);

  const [form] = Form.useForm();

  const showModal = (config) => {
    modalRef.current && modalRef.current.show(config);
  };

  const fetchData = async () => {
    dispatch(actions.changeLoading(true));
    const { table } = await API.getAnalysisData(projectId, 'Deal Rationale');
    setData(table);
    dispatch(actions.changeLoading(false));
    //when there is 'category' in location.state,show insight modal
    const historyState = location.state || {};
    if (historyState.category && !historyState.noModal) {
      showModal(historyState);
    }
    return table;
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleEditForm = () => {
    setEditButton(!editButton);
  };

  const handleCancel = () => {
    form.resetFields();
    setEditButton(true);
  };

  // const id = data && data[0].fieldValue;

  useEffect(() => {
    data &&
      data.forEach((item, i) => {
        formData.forEach((itm, idx) => {
          if (item.info?.resourceId === itm.linkName) {
            itm.hasLink = true;
            itm.linkData = item.fieldValue;
          }
          if (item.info?.resourceId === itm.name) {
            itm.info = { ...item.info, fieldValue: item.fieldValue };
          }
        });
      });
    const comp = formData.reduce(
      (res, c) => {
        const p = {
          edit: !editButton,
          form,
          handleCancel,
          showModal,
          ...c,
        };

        if (c.type === 'text' && c.name !== 'ourUnderstanding') {
          res.left.push(<DealItem {...p} />);
        } else if (c.name === 'ourUnderstanding') {
          res.top.push(<DealItem {...p} />);
        } else {
          res.right.push(<DealItem {...p} />);
        }
        if (c.info) {
          const { resourceId, fieldValue } = c.info;
          form.setFieldsValue({ [resourceId]: fieldValue });
        }

        return res;
      },

      { left: [], right: [], top: [] },
    );
    setComp(comp);
  }, [data]);

  useEffect(() => {
    const comp = formData.reduce(
      (res, c) => {
        const p = {
          edit: !editButton,
          form,
          handleCancel,
          showModal,
          ...c,
        };

        if (c.type === 'text' && c.name !== 'ourUnderstanding') {
          res.left.push(<DealItem {...p} />);
        } else if (c.name === 'ourUnderstanding') {
          res.top.push(<DealItem {...p} />);
        } else {
          res.right.push(<DealItem {...p} />);
        }
        if (c.info) {
          const { resourceId, fieldValue } = c.info;

          form.setFieldsValue({ [resourceId]: fieldValue });
        }

        return res;
      },
      { left: [], right: [], top: [] },
    );
    form.setFieldsValue({ ourUnderstanding: comp.top[0]?.info?.fieldValue });
    setComp(comp);
  }, [editButton]);

  // saveHandler
  const handleSubmit = async () => {
    setIsLoading(true);
    const res = form.getFieldsValue(true);
    const data = JSON.parse(JSON.stringify(res));
    for (const key in data) {
      data[key] = data[key] && data[key].trim() === '' ? '' : res[key];
    }
    await API.postDealRationale({ projectId, ...data });
    setEditButton(true);
    setIsLoading(false);
    form.resetFields();
    fetchData();
  };
  const isInternal = JSON.parse(
    window.localStorage.userInfo || '{}',
  ).isInternal;

  return (
    <div className="deal-rationale">
      <InsightModal
        ref={modalRef}
        segment="dealrationale"
        closeModalCallback={fetchData}
        disableScroll={true}
        rootNode=".insights"
      />
      <Dropdown section={DEAL_RATIONALE} />
      <SectionComment module={currentSubmoduleName} placement="bottomRight" />

      <div className="dealRationale-form">
        {isInternal && (
          <ShowButton
            onClick={handleEditForm}
            className="dealRationale-edit-button role-control"
            isLoading={isLoading}
            show={editButton}
            text="Edit"
          />
        )}
        <Form
          form={form}
          // name="dealRationale-form"
          layout="vertical"
          autoComplete="off"
        >
          {data && (
            <>
              <Row className="dealRationale-form-layout1">
                <Col style={{ width: '100%' }}>{comp.top}</Col>
              </Row>
              <Row className="dealRationale-form-layout">
                <Col
                  style={{ width: '25%' }}
                  className={editButton && 'dealRationale-left-layout'}
                >
                  {comp.left}
                </Col>
                <Col style={{ width: '72%' }}>{comp.right}</Col>
              </Row>
            </>
          )}

          <Row>
            <Col span={24} style={{ textAlign: 'right' }}>
              <ShowButton
                style={{ marginRight: 20 }}
                kind="secondary"
                onMouseDown={handleCancel}
                show={!editButton}
                isLoading={isLoading}
                text="Cancel"
              />
              <ShowButton
                isLoading={isLoading}
                show={!editButton}
                text="Save"
                onMouseDown={handleSubmit}
              />
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};
export default CommentAnchor(connect(() => {})(memo(DealRationale)), {
  shouldScrollInToView: (anchorRecord, anchorId) =>
    anchorRecord?.moduleName === anchorId,
  getAnchorIdFromProp(props) {
    return props.currentSubmoduleName;
  },
});
